import React, { useState } from "react";
import { api } from "@/lib/api";
import { Shield, FileLock } from "lucide-react";

const MedicalDental = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", category: "dental", message: "" });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/public/inquiry", { ...form });
      setSent(true);
      setForm({ name: "", email: "", phone: "", category: "dental", message: "" });
    } catch {}
  };

  return (
    <div data-testid="medical-dental-page">
      <section className="bg-navy text-white py-24 relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1762625570087-6d98fca29531?crop=entropy&cs=srgb&fm=jpg&q=85" alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <div className="overline text-gold">Healthcare Desk</div>
          <h1 className="font-display text-4xl lg:text-6xl mt-4 max-w-3xl">Dental & Medical practice brokerage.</h1>
          <p className="mt-6 max-w-xl text-white/75">Confidential, valuation-led transitions for solo operators, group practices, and DSOs.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-2 gap-6">
        {[
          { t: "Buy a Dental Practice", d: "Access to vetted buy-side dental opportunities, from GP to ortho and perio." },
          { t: "Sell a Dental Practice", d: "Confidential sell-side representation with seller-friendly deal structures." },
          { t: "Buy a Medical Clinic", d: "Multi-specialty, MOB, and ambulatory clinic acquisitions." },
          { t: "Sell a Medical Clinic", d: "Licensed operators, letter of intent, due diligence — handled end-to-end." },
        ].map((c) => (
          <div key={c.t} className="bg-white border border-slate-200 p-10" data-testid={`md-card-${c.t.toLowerCase().replace(/\s/g, "-")}`}>
            <div className="overline text-gold">Service</div>
            <h3 className="font-display text-2xl text-navy mt-3">{c.t}</h3>
            <p className="mt-4 text-slate-600 leading-relaxed">{c.d}</p>
          </div>
        ))}
      </section>

      <section className="bg-slate-50 py-20">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <div className="grid md:grid-cols-3 gap-6 mb-10">
            <div className="flex items-start gap-3"><Shield className="w-6 h-6 text-gold mt-0.5" /><div><div className="font-semibold text-navy">NDA-First Process</div><div className="text-sm text-slate-600 mt-1">Every engagement begins with an NDA.</div></div></div>
            <div className="flex items-start gap-3"><FileLock className="w-6 h-6 text-gold mt-0.5" /><div><div className="font-semibold text-navy">No Staff Notification</div><div className="text-sm text-slate-600 mt-1">Your team never learns until you say so.</div></div></div>
            <div className="flex items-start gap-3"><Shield className="w-6 h-6 text-gold mt-0.5" /><div><div className="font-semibold text-navy">Qualified Buyers Only</div><div className="text-sm text-slate-600 mt-1">Pre-qualified buyer universe.</div></div></div>
          </div>

          <form onSubmit={submit} className="bg-white border border-slate-200 p-8 lg:p-10" data-testid="confidential-form">
            <div className="overline text-gold">Confidential</div>
            <h2 className="font-display text-3xl text-navy mt-3">Request a confidential conversation</h2>
            <p className="mt-3 text-slate-600">All inquiries are NDA-protected. Nothing leaves this form without your written consent.</p>
            {sent ? (
              <div className="mt-6 p-4 bg-slate-50 border border-gold text-navy" data-testid="confidential-success">Thank you. A senior advisor will reach out via private channel within 24 hours.</div>
            ) : (
              <div className="mt-6 space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <input required placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="conf-name" />
                  <input required type="email" placeholder="Email (private)" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="conf-email" />
                </div>
                <input placeholder="Phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="w-full border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="conf-phone" />
                <select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="w-full border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold bg-white" data-testid="conf-category">
                  <option value="dental">Dental practice</option>
                  <option value="medical">Medical clinic</option>
                </select>
                <textarea required rows="4" placeholder="Briefly describe your situation" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="conf-message" />
                <button className="btn-navy w-full" data-testid="conf-submit">Send Confidential Message</button>
              </div>
            )}
          </form>
        </div>
      </section>
    </div>
  );
};

export default MedicalDental;
